<style>
    .notification-container {
        z-index: 6001;
        height: 100vh;
        width: 60%;
        min-width: 800px;
        margin: auto;
        overflow-y: scroll;
    }
    .notification-container::-webkit-scrollbar-thumb {
        background: transparent !important;
    }
    .notification-container::-webkit-scrollbar-track {
        background: transparent !important;
    }
    .night-mode, label.night-mode {
        color: white;
    }
    .settings-container {
        margin: 10px auto 12px -150px;
        float: right;
    }
    .k-tabstrip-tabpanel {
        background-color: transparent !important;
    }
    
	.k-widget {
    font-size: 13px;
}

.k-header{
	border-color: rgba(0, 0, 0, 0.08);
}

.k-tabstrip {
    border-width: 0;
    border-color: transparent;
    box-sizing: border-box;
    outline: 0;
    font-family: inherit;
    font-size: 14px;
    line-height: 1.42857143;
    color: inherit;
    background-color: transparent;
    display: flex;
    flex-direction: column;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.notification-container .k-tabstrip-top > .k-tabstrip-items {
    border-bottom: 1px solid white;
    margin-top: 20px;
}

.notification-container .k-tabstrip-items .k-state-default {
    color: black;
    width: 90px;
    text-align: center;
    margin-right: 10px;
}

.notification-container .k-tabstrip-items .k-item.k-state-active, .notification-container .k-tabstrip-items .k-item.k-state-selected {
    color: white;
    background-color: darkgrey;
}

.k-tabstrip-items {
    border-width: 0;
    border-style: solid;
    border-color: inherit;
    outline: 0;
    display: flex;
    flex-direction: row;
    flex: 0 0 auto;
    position: relative;
}

.k-reset {
    margin: 0;
    padding: 0;
    border-width: 0;
    outline: 0;
    font: inherit;
    text-decoration: none;
    list-style: none;
}

.checkbox label {
    height: 13px;
    width: 13px;
    padding-left: 0;
    margin-bottom: unset;
    font-weight: 400;
    cursor: pointer;
}

.checkbox label:before{
	background-color: #fff !important;
	border-color: 1px solid #cccccc !important;
    width: 13px;
    height: 13px;
}

.checkbox-success input[type=checkbox]:checked+label:before{
	border-color: 1px solid #cccccc;
}

.k-tabstrip-content, .k-tabstrip>.k-content {
    background: transparent !important;
    border: none;
    outline-width: 0 !important;
}

.checkbox-success input[type="checkbox"]:checked + label::before {
    background-color: var(--primary) !important;
    border-color: var(--primary) !important;
    margin-left: -19px !important;
}

.checkbox label::before {
    border: 1px solid var(--primary);
    opacity: 1;
    margin-left: -19px !important;
}

.checkbox input[type="checkbox"], .checkbox input[type="radio"] {
    opacity: 0;
    z-index: 1;
}

input[type="checkbox"].styled:checked + label:after, input[type="radio"].styled:checked + label:after {
    font-family: 'FontAwesome';
    content: "\f00c";
}

.checkbox-success input[type="checkbox"]:checked + label::after, .checkbox-success input[type="radio"]:checked + label::after {
    color: #fff;
    width: 13px;
    height: 13px;
}

.k-tabstrip-top>.k-tabstrip-items-wrapper {
    padding-top: 20px;
    border-bottom: 1px solid white;
}

.k-tabstrip-items-wrapper .k-item:focus, .k-tabstrip-items-wrapper .k-item.k-focus {
    box-shadow: none;
    background-color: darkgray;
    color: white;
}

.k-tabstrip-items-wrapper .k-item:active, .k-tabstrip-items-wrapper .k-item.k-active, .k-tabstrip-items-wrapper .k-item.k-selected {
    background-color: darkgray;
    color: white;
}

.k-tabstrip-content, .k-tabstrip>.k-content {
    padding-block: 0;
    padding-inline: 0;
}

.k-tabstrip-items-wrapper .k-item {
    color: #000000;
}


</style>
<div class="notification-container" [ngClass]="{'night-mode': nightMode}">
    <div class="settings-container">
        <div class="form-check-lg checkbox checkbox-success">
			<input class="styled" style="cursor: pointer;" name="nightMode" type="checkbox" [(ngModel)]="nightMode" (change)="nightModeChange()">
			<label class="color-prussian">|</label>
			<span style="color: white;">Night Mode</span>
		</div>
		<div class="form-check-lg checkbox checkbox-success">
			<input class="styled" style="cursor: pointer;" name="nightMode" type="checkbox" [(ngModel)]="groupByCategory" (change)="groupByCategoryChange()">
			<label class="color-prussian">|</label>
			<span style="color: white;">Group Items</span>
        </div>
    </div>
    <kendo-tabstrip (tabSelect)="onTabSelect($event)" class="k-tabstrip-tabpanel" style="background-color: transparent">
        <kendo-tabstrip-tab [title]="'Active'" [selected]="selectedTab == 'Active'">
            <ng-template kendoTabContent>
                <div *ngIf="!isNotificationFetched" class="loader-div">
                    <span class="k-loading-image" style="color: #000000;"></span>
                </div>
                <notification-container
                    [notificationCategories]="notificationCategories"
                    [nightMode] = "nightMode"
                    [groupByCategory]= "groupByCategory"
                    [activeView]= "activeView">
                </notification-container>
            </ng-template>
        </kendo-tabstrip-tab>
        <kendo-tabstrip-tab [title]="'Dismissed'" [selected]="selectedTab == 'Dismissed'">
            <ng-template kendoTabContent>
                <div *ngIf="!isNotificationFetched" class="loader-div">
                    <span class="k-loading-image" style="color: #000000;"></span>
                </div>
                <notification-container
                    [notificationCategories]="dismissedCategories"
                    [nightMode] = "nightMode"
                    [groupByCategory]= "groupByCategory">
                </notification-container>
            </ng-template>
        </kendo-tabstrip-tab>
    </kendo-tabstrip>
</div>